import type {MutationFunction} from '@apollo/react-common';
import {useMutation} from '@apollo/react-hooks';

import type {
    GetCalendarSync as GetCalendarSyncQuery,
    setOffice365CalendarSyncIsEnabled as setOffice365CalendarSyncIsEnabledMutation,
    setOffice365CalendarSyncIsEnabledVariables as setOffice365CalendarSyncIsEnabledMutationVariables,
} from 'nutshell-graphql-types';

import SET_OFFICE365_CALENDAR_SYNC_IS_ENABLED from '../mutations/set-office365-calendar-sync-is-enabled.graphql';
import GET_CALENDAR_SYNC_QUERY from '../queries/get-calendar-sync.graphql';

export function useSetOffice365CalendarSyncIsEnabled(): {
    setOffice365CalendarSyncIsEnabled: (isEnabled: boolean) => Promise<any>;
    enableO365: MutationFunction<
        setOffice365CalendarSyncIsEnabledMutation,
        setOffice365CalendarSyncIsEnabledMutationVariables
    >;
    isLoading: boolean;
} {
    const [setOffice365CalendarSyncIsEnabled, {loading}] = useMutation<
        setOffice365CalendarSyncIsEnabledMutation,
        setOffice365CalendarSyncIsEnabledMutationVariables
    >(SET_OFFICE365_CALENDAR_SYNC_IS_ENABLED);

    return {
        setOffice365CalendarSyncIsEnabled: (isEnabled: boolean) => {
            return setOffice365CalendarSyncIsEnabled({
                variables: {isEnabled},
                update: (proxy, mutationResults) => {
                    const cacheResult: GetCalendarSyncQuery | null | undefined = proxy.readQuery({
                        query: GET_CALENDAR_SYNC_QUERY,
                    });

                    if (!cacheResult || !cacheResult.loggedInUser) {
                        return;
                    }

                    const updatedCalendarSync =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.setOffice365CalendarSyncIsEnabled &&
                        mutationResults.data.setOffice365CalendarSyncIsEnabled.calendarSync;

                    if (!updatedCalendarSync) return;

                    proxy.writeQuery({
                        query: GET_CALENDAR_SYNC_QUERY,
                        data: {
                            loggedInUser: {
                                ...cacheResult.loggedInUser,
                                calendarSync: updatedCalendarSync,
                            },
                        },
                    });
                },
            });
        },
        enableO365: setOffice365CalendarSyncIsEnabled,
        isLoading: loading,
    };
}
